module.exports = (parcelRequire.load("1rEcN")).then(() => parcelRequire('iij5j'));